module.exports = __webpack_public_path__ + "static/media/male07.cc6365d6.jpg";